// extracted by mini-css-extract-plugin
module.exports = {"form":"TruckCompartmentForm_form__2mX4E"};